import React, { useEffect, useState } from 'react';
import QRCode from 'qrcode';
import { X, Printer, QrCode } from 'lucide-react';
import { useT } from '../context/LanguageContext';

const eur = (n) => (Number(n) || 0).toLocaleString('nl-NL', { style: 'currency', currency: 'EUR', maximumFractionDigits: 0 });

// Compacte payload die de in-app scanner herkent
export const partQrPayload = (p) => `MCPART:${p.id}`;

export default function PartLabel({ part, garageNaam, onClose }) {
  const { t } = useT();
  const [qr, setQr] = useState('');

  useEffect(() => {
    QRCode.toDataURL(partQrPayload(part), { margin: 1, width: 320, errorCorrectionLevel: 'M' })
      .then(setQr).catch(() => setQr(''));
  }, [part]);

  const print = () => {
    const w = window.open('', '_blank', 'width=420,height=560');
    if (!w) return;
    w.document.write(`<!doctype html><html><head><title>Label ${part.naam || ''}</title>
      <style>
        @page { size: 62mm 90mm; margin: 4mm; }
        * { box-sizing: border-box; font-family: -apple-system, Segoe UI, Roboto, sans-serif; }
        body { margin: 0; padding: 8px; }
        .lbl { border: 2px solid #0f172a; border-radius: 8px; padding: 10px; text-align: center; }
        .naam { font-size: 15px; font-weight: 800; color: #0f172a; line-height: 1.2; margin-bottom: 6px; }
        .qr { width: 150px; height: 150px; margin: 4px auto; }
        .row { font-size: 12px; color: #1e293b; margin: 2px 0; }
        .loc { font-size: 20px; font-weight: 800; letter-spacing: 1px; margin: 4px 0; }
        .nr { font-family: ui-monospace, monospace; font-size: 11px; color: #475569; }
        .prijs { font-size: 16px; font-weight: 800; color: #16a34a; margin-top: 4px; }
        .garage { font-size: 10px; color: #94a3b8; margin-top: 6px; }
      </style></head><body>
      <div class="lbl">
        <div class="naam">${(part.naam || '—').replace(/</g, '&lt;')}</div>
        <img class="qr" src="${qr}" />
        ${part.magazijnLocatie ? `<div class="loc">📍 ${String(part.magazijnLocatie).replace(/</g, '&lt;')}</div>` : ''}
        ${part.onderdeelNummer ? `<div class="nr">${String(part.onderdeelNummer).replace(/</g, '&lt;')}</div>` : ''}
        ${part.oemNummer ? `<div class="nr">OEM: ${String(part.oemNummer).replace(/</g, '&lt;')}</div>` : ''}
        ${part.vraagPrijs ? `<div class="prijs">${eur(part.vraagPrijs)}</div>` : ''}
        <div class="garage">${(garageNaam || 'MonteurCentraal').replace(/</g, '&lt;')}</div>
      </div>
      <script>window.onload=function(){setTimeout(function(){window.print();},250);};<\/script>
      </body></html>`);
    w.document.close();
  };

  return (
    <div className="cs-modal-overlay" onClick={onClose}>
      <div className="cs-modal" onClick={e => e.stopPropagation()} style={{ maxWidth: 360, textAlign: 'center' }} data-testid="part-label-modal">
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
          <h3 style={{ margin: 0, display: 'flex', alignItems: 'center', gap: 8 }}><QrCode size={18} /> {t('Magazijnlabel', 'Magazijnlabel')}</h3>
          <button className="cs-btn ghost" onClick={onClose} data-testid="pl-close"><X size={16} /></button>
        </div>
        <div style={{ border: '2px solid #0f172a', borderRadius: 10, padding: 16, margin: '0 auto', maxWidth: 240 }}>
          <div style={{ fontWeight: 800, fontSize: 15, color: '#0f172a', marginBottom: 8 }}>{part.naam || '—'}</div>
          {qr ? <img src={qr} alt="QR" style={{ width: 150, height: 150 }} data-testid="pl-qr" /> : <div style={{ height: 150 }} />}
          {part.magazijnLocatie && <div style={{ fontSize: 20, fontWeight: 800, marginTop: 6 }}>📍 {part.magazijnLocatie}</div>}
          {part.onderdeelNummer && <div style={{ fontFamily: 'ui-monospace, monospace', fontSize: 12, color: '#475569' }}>{part.onderdeelNummer}</div>}
          {!!part.vraagPrijs && <div style={{ fontSize: 16, fontWeight: 800, color: '#16a34a', marginTop: 4 }}>{eur(part.vraagPrijs)}</div>}
        </div>
        <button className="cs-btn primary" onClick={print} data-testid="pl-print" style={{ marginTop: 16, width: '100%', justifyContent: 'center' }}>
          <Printer size={15} /> {t('Label afdrukken', 'Label afdrukken')}
        </button>
        <p style={{ fontSize: 11.5, color: '#94a3b8', marginTop: 8 }}>{t('Scan deze code met "Scannen" om dit onderdeel direct terug te vinden.', 'Scan deze code met "Scannen" om dit onderdeel direct terug te vinden.')}</p>
      </div>
    </div>
  );
}
